export const DashboardIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.4 10.4H8C9.6 10.4 10.4 9.6 10.4 8V6.4C10.4 4.8 9.6 4 8 4H6.4C4.8 4 4 4.8 4 6.4V8C4 9.6 4.8 10.4 6.4 10.4Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M15.9998 10.4H17.5998C19.1998 10.4 19.9998 9.6 19.9998 8V6.4C19.9998 4.8 19.1998 4 17.5998 4H15.9998C14.3998 4 13.5998 4.8 13.5998 6.4V8C13.5998 9.6 14.3998 10.4 15.9998 10.4Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M15.9998 19.9999H17.5998C19.1998 19.9999 19.9998 19.1999 19.9998 17.5999V15.9999C19.9998 14.3999 19.1998 13.5999 17.5998 13.5999H15.9998C14.3998 13.5999 13.5998 14.3999 13.5998 15.9999V17.5999C13.5998 19.1999 14.3998 19.9999 15.9998 19.9999Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M6.4 19.9999H8C9.6 19.9999 10.4 19.1999 10.4 17.5999V15.9999C10.4 14.3999 9.6 13.5999 8 13.5999H6.4C4.8 13.5999 4 14.3999 4 15.9999V17.5999C4 19.1999 4.8 19.9999 6.4 19.9999Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>

    // icon code end
  );
};

export const DashboardBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.4 10.4H8C9.6 10.4 10.4 9.6 10.4 8V6.4C10.4 4.8 9.6 4 8 4H6.4C4.8 4 4 4.8 4 6.4V8C4 9.6 4.8 10.4 6.4 10.4Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9998 10.4H17.5998C19.1998 10.4 19.9998 9.6 19.9998 8V6.4C19.9998 4.8 19.1998 4 17.5998 4H15.9998C14.3998 4 13.5998 4.8 13.5998 6.4V8C13.5998 9.6 14.3998 10.4 15.9998 10.4Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9998 19.9999H17.5998C19.1998 19.9999 19.9998 19.1999 19.9998 17.5999V15.9999C19.9998 14.3999 19.1998 13.5999 17.5998 13.5999H15.9998C14.3998 13.5999 13.5998 14.3999 13.5998 15.9999V17.5999C13.5998 19.1999 14.3998 19.9999 15.9998 19.9999Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4 19.9999H8C9.6 19.9999 10.4 19.1999 10.4 17.5999V15.9999C10.4 14.3999 9.6 13.5999 8 13.5999H6.4C4.8 13.5999 4 14.3999 4 15.9999V17.5999C4 19.1999 4.8 19.9999 6.4 19.9999Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const LotteryIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.91 14.6925C18.91 15.9825 19.97 17.0325 21.26 17.0325C21.26 20.7825 20.32 21.7225 16.57 21.7225H7.19C3.44 21.7225 2.5 20.7825 2.5 17.0325V16.5725C3.79 16.5725 4.85 15.5125 4.85 14.2225C4.85 12.9325 3.79 11.8725 2.5 11.8725V11.4125C2.51 7.66247 3.44 6.72247 7.19 6.72247H16.56C20.31 6.72247 21.25 7.66247 21.25 11.4125V12.3525C19.96 12.3525 18.91 13.3925 18.91 14.6925Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M16.2111 6.7225H7.12109L10.0511 3.7925C12.4411 1.4025 13.6411 1.4025 16.0311 3.7925L16.6311 4.3925C16.0011 5.0225 15.8511 5.9525 16.2111 6.7225Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M9.87891 6.72266L9.87891 21.7227"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="5 5"
        className={className}
      />
    </svg>

    // icon code end
  );
};

export const LotteryBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.19 4.96C17.19 4.97 17.19 4.97 17.19 4.98C16.94 4.97 16.69 4.96 16.42 4.96H8.72L9.79 3.9C10.77 2.91 11.85 2 13.1 2C14.36 2 15.44 2.91 16.42 3.9L16.98 4.46C17.12 4.59 17.19 4.77 17.19 4.96Z"
        fill="white"
      />
      <path
        d="M20.84 13.17C21.23 13.17 21.54 12.85 21.54 12.45V11.57C21.54 7.64001 20.34 6.45001 16.42 6.45001H10.12H7.57999C3.65999 6.45001 2.45999 7.65001 2.45999 11.57V12C2.45999 12.4 2.76999 12.71 3.15999 12.71C3.99999 12.71 4.66999 13.39 4.66999 14.22C4.66999 15.05 3.99999 15.74 3.15999 15.74C2.76999 15.74 2.45999 16.05 2.45999 16.45V16.88C2.45999 20.81 3.65999 22 7.57999 22H10.11H16.41C20.33 22 21.53 20.8 21.53 16.88C21.53 16.49 21.22 16.17 20.83 16.17C19.99 16.17 19.32 15.5 19.32 14.67C19.33 13.84 20 13.17 20.84 13.17ZM10.82 18.86C10.82 19.25 10.5 19.57 10.11 19.57C9.71999 19.57 9.39999 19.25 9.39999 18.86V16.18C9.39999 15.79 9.71999 15.47 10.11 15.47C10.5 15.47 10.82 15.79 10.82 16.18V18.86ZM10.82 12.27C10.82 12.66 10.5 12.98 10.11 12.98C9.71999 12.98 9.39999 12.66 9.39999 12.27V9.59001C9.39999 9.20001 9.71999 8.88001 10.11 8.88001C10.5 8.88001 10.82 9.20001 10.82 9.59001V12.27Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const UserIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.9975 7.16C17.9375 7.15 17.8675 7.15 17.8075 7.16C16.4275 7.11 15.3275 5.98 15.3275 4.58C15.3275 3.15 16.4775 2 17.9075 2C19.3375 2 20.4875 3.16 20.4875 4.58C20.4775 5.98 19.3775 7.11 17.9975 7.16Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M16.9675 14.4402C18.3375 14.6702 19.8475 14.4302 20.9075 13.7202C22.3175 12.7802 22.3175 11.2402 20.9075 10.3002C19.8375 9.59016 18.3075 9.35016 16.9375 9.59016"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M5.96751 7.16C6.02751 7.15 6.09751 7.15 6.15751 7.16C7.53751 7.11 8.63751 5.98 8.63751 4.58C8.63751 3.15 7.48751 2 6.05751 2C4.62751 2 3.47751 3.16 3.47751 4.58C3.48751 5.98 4.58751 7.11 5.96751 7.16Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M6.9975 14.4402C5.6275 14.6702 4.1175 14.4302 3.0575 13.7202C1.6475 12.7802 1.6475 11.2402 3.0575 10.3002C4.1275 9.59016 5.6575 9.35016 7.0275 9.59016"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M11.9975 14.6307C11.9375 14.6207 11.8675 14.6207 11.8075 14.6307C10.4275 14.5807 9.32751 13.4507 9.32751 12.0507C9.32751 10.6207 10.4775 9.4707 11.9075 9.4707C13.3375 9.4707 14.4875 10.6307 14.4875 12.0507C14.4775 13.4507 13.3775 14.5907 11.9975 14.6307Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M9.0875 17.7794C7.6775 18.7194 7.6775 20.2594 9.0875 21.1994C10.6875 22.2694 13.3075 22.2694 14.9075 21.1994C16.3175 20.2594 16.3175 18.7194 14.9075 17.7794C13.3175 16.7194 10.6875 16.7194 9.0875 17.7794Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>

    // icon code end
  );
};

export const UserBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.535 7.77C17.465 7.76 17.395 7.76 17.325 7.77C15.775 7.72 14.545 6.45 14.545 4.89C14.545 3.3 15.835 2 17.435 2C19.025 2 20.325 3.29 20.325 4.89C20.315 6.45 19.085 7.72 17.535 7.77Z"
        fill="white"
      />
      <path
        d="M20.795 14.7004C19.675 15.4504 18.105 15.7304 16.655 15.5404C17.035 14.7204 17.235 13.8104 17.245 12.8504C17.245 11.8504 17.025 10.9004 16.605 10.0704C18.085 9.8704 19.655 10.1504 20.785 10.9004C22.365 11.9404 22.365 13.6504 20.795 14.7004Z"
        fill="white"
      />
      <path
        d="M6.44498 7.77C6.51498 7.76 6.58498 7.76 6.65498 7.77C8.20498 7.72 9.43498 6.45 9.43498 4.89C9.43498 3.29 8.14498 2 6.54498 2C4.95498 2 3.66498 3.29 3.66498 4.89C3.66498 6.45 4.89498 7.72 6.44498 7.77Z"
        fill="white"
      />
      <path
        d="M6.555 12.8506C6.555 13.8206 6.765 14.7406 7.145 15.5706C5.735 15.7206 4.265 15.4206 3.185 14.7106C1.605 13.6606 1.605 11.9506 3.185 10.9006C4.255 10.1806 5.765 9.89059 7.185 10.0506C6.775 10.8906 6.555 11.8406 6.555 12.8506Z"
        fill="white"
      />
      <path
        d="M12.125 15.87C12.045 15.86 11.955 15.86 11.865 15.87C10.025 15.81 8.55499 14.3 8.55499 12.44C8.56499 10.54 10.095 9 12.005 9C13.905 9 15.445 10.54 15.445 12.44C15.435 14.3 13.975 15.81 12.125 15.87Z"
        fill="white"
      />
      <path
        d="M8.87499 17.9406C7.36499 18.9506 7.36499 20.6106 8.87499 21.6106C10.595 22.7606 13.415 22.7606 15.135 21.6106C16.645 20.6006 16.645 18.9406 15.135 17.9406C13.425 16.7906 10.605 16.7906 8.87499 17.9406Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const SliderIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6534 7.15209C18.6934 7.76209 18.6434 8.45209 18.5234 9.22209L17.7934 13.9121C17.1734 17.8221 15.3634 19.1421 11.4534 18.5321L6.76343 17.7921C5.41343 17.5821 4.37343 17.2221 3.61343 16.6821C2.16343 15.6721 1.74343 14.0121 2.14343 11.4521L2.88343 6.76209C3.50343 2.85209 5.31343 1.53209 9.22343 2.14209L13.9134 2.88209C17.0534 3.37209 18.5234 4.65209 18.6534 7.15209Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M20.5233 13.4723L19.0233 17.9823C17.7733 21.7423 15.7733 22.7423 12.0133 21.4923L7.50328 19.9923C5.23328 19.2423 3.97328 18.2023 3.61328 16.6823C4.37328 17.2223 5.41328 17.5823 6.76328 17.7923L11.4533 18.5323C15.3633 19.1423 17.1733 17.8223 17.7933 13.9123L18.5233 9.22234C18.6433 8.45234 18.6933 7.76234 18.6533 7.15234C21.0433 8.42234 21.5633 10.3423 20.5233 13.4723Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M8.26344 8.98195C9.22441 8.98195 10.0034 8.20293 10.0034 7.24195C10.0034 6.28098 9.22441 5.50195 8.26344 5.50195C7.30246 5.50195 6.52344 6.28098 6.52344 7.24195C6.52344 8.20293 7.30246 8.98195 8.26344 8.98195Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>

    // icon code end
  );
};

export const SliderBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.89 2.88002L9.19999 2.14002C5.28999 1.53002 3.47999 2.85002 2.85999 6.76002L2.11999 11.45C1.71999 14.01 2.13999 15.67 3.58999 16.68C4.34999 17.22 5.38999 17.58 6.73999 17.79L11.43 18.53C15.34 19.14 17.15 17.82 17.77 13.91L18.5 9.22002C18.62 8.45002 18.67 7.76002 18.63 7.15002C18.5 4.65002 17.03 3.37002 13.89 2.88002ZM8.23999 9.35002C7.06999 9.35002 6.11999 8.40002 6.11999 7.24002C6.11999 6.07002 7.06999 5.12002 8.23999 5.12002C9.39999 5.12002 10.35 6.07002 10.35 7.24002C10.35 8.40002 9.39999 9.35002 8.23999 9.35002Z"
        fill="white"
      />
      <path
        d="M20.5 13.47L19 17.98C17.75 21.74 15.75 22.74 11.99 21.49L7.48001 19.99C6.07001 19.52 5.05001 18.94 4.39001 18.21C5.02001 18.46 5.75001 18.65 6.58001 18.78L11.28 19.52C11.92 19.62 12.52 19.67 13.08 19.67C16.38 19.67 18.15 17.89 18.76 14.06L19.49 9.37C19.59 8.79 19.63 8.28 19.63 7.81C21.15 9.06 21.37 10.84 20.5 13.47Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const EventIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2C16 2 17 3.01 17 5.03V12.08C17 14.07 15.59 14.84 13.86 13.8L12.54 13C12.24 12.82 11.76 12.82 11.46 13L10.14 13.8C8.41 14.84 7 14.07 7 12.08V5.03C7 3.01 8 2 10 2H14Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.82 4.99002C3.41 5.56002 2 7.66002 2 11.9V14.93C2 19.98 4 22 9 22H15C20 22 22 19.98 22 14.93V11.9C22 7.59002 20.54 5.48002 17 4.96002"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const EventBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 4.96V12.08C17 14.07 15.59 14.84 13.86 13.8L12.54 13C12.24 12.82 11.76 12.82 11.46 13L10.14 13.8C8.41 14.84 7 14.07 7 12.08V4.99C7.01 3 8.01 2 10 2H14C15.98 2 16.98 2.99 17 4.96Z"
        fill="white"
      />
      <path
        d="M22 11.9V14.93C22 19.98 20 22 15 22H9C4 22 2 19.98 2 14.93V11.9C2 9.20998 2.57 7.37998 3.85 6.25998C4.5 5.70998 5.5 6.18998 5.5 7.03998V12.08C5.5 13.57 6.11 14.77 7.17 15.37C8.24 15.98 9.6 15.87 10.92 15.08L12 14.43L13.09 15.08C13.83 15.53 14.6 15.76 15.32 15.76C15.86 15.76 16.37 15.63 16.83 15.37C17.89 14.77 18.5 13.57 18.5 12.08V7.02998C18.5 6.17998 19.51 5.69998 20.15 6.25998C21.43 7.37998 22 9.20998 22 11.9Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const PartnerIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.44 19.05L15.96 20.57L19 17.53"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.16 10.87C12.06 10.86 11.94 10.86 11.83 10.87C9.45 10.79 7.56 8.84 7.56 6.44C7.55 3.99 9.54 2 11.99 2C14.44 2 16.43 3.99 16.43 6.44C16.43 8.84 14.53 10.79 12.16 10.87Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.99 21.81C10.17 21.81 8.36001 21.35 6.98001 20.43C4.56001 18.81 4.56001 16.17 6.98001 14.56C9.73001 12.72 14.24 12.72 16.99 14.56"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const PartnerBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
        fill="white"
      />
      <path
        d="M17.08 14.16C14.29 12.3 9.73999 12.3 6.92999 14.16C5.65999 15 4.95999 16.15 4.95999 17.38C4.95999 18.61 5.65999 19.75 6.91999 20.59C8.31999 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.14 18.34 14.99 17.08 14.16ZM14.33 16.56L11.81 19.08C11.69 19.2 11.53 19.26 11.37 19.26C11.21 19.26 11.05 19.19 10.93 19.08L9.66999 17.82C9.42999 17.58 9.42999 17.18 9.66999 16.94C9.90999 16.7 10.31 16.7 10.55 16.94L11.37 17.76L13.45 15.68C13.69 15.44 14.09 15.44 14.33 15.68C14.58 15.92 14.58 16.32 14.33 16.56Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const ChatIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}>
      <path
        d="M17.9962 10.7765V14.7701C17.9962 15.0297 17.9862 15.2793 17.9561 15.5189C17.7259 18.2145 16.1343 19.5524 13.2013 19.5524H12.8009C12.5507 19.5524 12.3104 19.6722 12.1603 19.8719L10.9591 21.4693C10.4285 22.1782 9.56765 22.1782 9.03711 21.4693L7.83589 19.8719C7.70575 19.7021 7.41548 19.5524 7.19525 19.5524H6.79486C3.60163 19.5524 2 18.7637 2 14.7701V10.7765C2 7.85117 3.35137 6.26372 6.0441 6.03409C6.28434 6.00413 6.53459 5.99414 6.79486 5.99414H13.2013C16.3946 5.99414 17.9962 7.59159 17.9962 10.7765Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0003 6.78234V10.7759C22.0003 13.7112 20.6489 15.2887 17.9562 15.5183C17.9863 15.2787 17.9963 15.0291 17.9963 14.7695V10.7759C17.9963 7.59104 16.3946 5.99359 13.2014 5.99359H6.79495C6.53469 5.99359 6.28443 6.00359 6.04419 6.03354C6.27442 3.34785 7.86603 2 10.799 2H17.2055C20.3987 2 22.0003 3.59745 22.0003 6.78234Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5072 13.2316H13.5162"
        stroke="#A1A1A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0037 13.2316H10.0127"
        stroke="#A1A1A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50003 13.2316H6.50904"
        stroke="#A1A1A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const ChatBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7615 9.62708V13.553C16.7615 13.8082 16.7518 14.0536 16.723 14.2891C16.5017 16.9391 14.9724 18.2543 12.1542 18.2543H11.7695C11.529 18.2543 11.2981 18.372 11.1539 18.5683L9.99965 20.1387C9.01818 21.4809 9.01818 21.0713 8.15289 20.1387L6.99866 18.5683C6.87362 18.4015 6.59469 18.2543 6.38309 18.2543H5.99835C2.93005 18.2543 1.39108 17.4789 1.39108 13.553V9.62708C1.39108 6.75134 2.68959 5.19079 5.27697 4.96505C5.50781 4.9356 5.74827 4.92578 5.99835 4.92578H12.1542C15.2225 4.92578 16.7615 6.49616 16.7615 9.62708Z"
        fill="#E6E6E6"
        stroke="#E6E6E6"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6089 5.7013V9.62721C20.6089 12.5128 19.3104 14.0635 16.723 14.2892C16.7519 14.0537 16.7615 13.8083 16.7615 13.5531V9.62721C16.7615 6.49629 15.2225 4.92592 12.1542 4.92592H5.9984C5.74831 4.92592 5.50785 4.93574 5.27701 4.96519C5.49823 2.32501 7.02758 1 9.8458 1H16.0016C19.0699 1 20.6089 2.57038 20.6089 5.7013Z"
        stroke="#E6E6E6"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.448 12.0435H12.4567"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08158 12.0435H9.09023"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71515 12.0435H5.72381"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const HistoryIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 2V5"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V5"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11H15"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 15H12"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 22H9C4 22 3 19.94 3 15.82V9.65C3 4.95 4.67 3.69 8 3.5H16C19.33 3.68 21 4.95 21 9.65V16"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16L15 22V19C15 17 16 16 18 16H21Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const HistoryBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.29001 7.28854C7.87001 7.28854 7.54001 6.94854 7.54001 6.53854V3.74854C7.54001 3.33854 7.87001 2.99854 8.29001 2.99854C8.71001 2.99854 9.04001 3.33854 9.04001 3.74854V6.52854C9.04001 6.94854 8.71001 7.28854 8.29001 7.28854Z"
        fill="white"
      />
      <path
        d="M15.71 7.28854C15.29 7.28854 14.96 6.94854 14.96 6.53854V3.74854C14.96 3.32854 15.3 2.99854 15.71 2.99854C16.13 2.99854 16.46 3.33854 16.46 3.74854V6.52854C16.46 6.94854 16.13 7.28854 15.71 7.28854Z"
        fill="white"
      />
      <path
        d="M21.5 16.8186C21.5 16.9686 21.45 17.1186 21.32 17.2486C19.87 18.7086 17.29 21.3086 15.81 22.7986C15.68 22.9386 15.51 22.9986 15.34 22.9986C15.01 22.9986 14.69 22.7386 14.69 22.3586V18.8586C14.69 17.3986 15.93 16.1886 17.45 16.1886C18.4 16.1786 19.72 16.1786 20.85 16.1786C21.24 16.1786 21.5 16.4886 21.5 16.8186Z"
        fill="white"
      />
      <path
        d="M21.5 16.8186C21.5 16.9686 21.45 17.1186 21.32 17.2486C19.87 18.7086 17.29 21.3086 15.81 22.7986C15.68 22.9386 15.51 22.9986 15.34 22.9986C15.01 22.9986 14.69 22.7386 14.69 22.3586V18.8586C14.69 17.3986 15.93 16.1886 17.45 16.1886C18.4 16.1786 19.72 16.1786 20.85 16.1786C21.24 16.1786 21.5 16.4886 21.5 16.8186Z"
        fill="white"
      />
      <path
        d="M19.57 5.49854C18.91 5.00854 17.96 5.47854 17.96 6.30854V6.40854C17.96 7.57854 17.12 8.65854 15.95 8.77854C14.6 8.91854 13.46 7.85854 13.46 6.53854V5.49854C13.46 4.94854 13.01 4.49854 12.46 4.49854H11.54C10.99 4.49854 10.54 4.94854 10.54 5.49854V6.40854C10.54 7.28854 10.07 8.10854 9.34 8.50854C9.3 8.53854 9.26 8.55854 9.22 8.57854C9.21 8.57854 9.21 8.58854 9.2 8.58854C9.13 8.61854 9.06 8.64853 8.98 8.67853C8.96 8.68854 8.94 8.68853 8.92 8.69853C8.8 8.73853 8.67 8.76854 8.53 8.77854H8.52C8.37 8.79854 8.21 8.79854 8.06 8.77854H8.05C7.91 8.76854 7.78 8.73853 7.66 8.69853C7.56 8.66853 7.46 8.62854 7.36 8.57854C6.58 8.22854 6.04 7.44854 6.04 6.53854V6.30854C6.04 5.53854 5.22 5.07853 4.57 5.40854C4.56 5.41853 4.55 5.41853 4.54 5.42853H4.53C4.46 5.47853 4.4 5.52854 4.33 5.57854C4.22 5.66854 4.11 5.75854 4.01 5.85854C3.94 5.92854 3.87 5.99854 3.81 6.06854C3.73 6.14854 3.66 6.22854 3.59 6.31854C3.54 6.37854 3.48 6.43854 3.44 6.50854C3.39 6.56854 3.35 6.63854 3.31 6.69853C3.3 6.70853 3.29 6.71853 3.28 6.73853C3.19 6.86854 3.11 7.01853 3.04 7.15854C3.02 7.17853 3.01 7.18854 3.01 7.20854C2.95 7.32854 2.89 7.44853 2.85 7.57854C2.82 7.62854 2.81 7.66853 2.79 7.71853C2.77 7.75853 2.76 7.80854 2.74 7.84854C2.71 7.94853 2.68 8.05854 2.65 8.16854C2.61 8.30854 2.58 8.45854 2.56 8.60854C2.54 8.71854 2.53 8.82854 2.52 8.94853C2.51 9.08853 2.5 9.22854 2.5 9.36854V18.1285C2.5 20.8185 4.68 22.9985 7.37 22.9985H12.19C12.74 22.9985 13.19 22.5485 13.19 21.9985V18.8585C13.19 16.5585 15.1 14.6885 17.45 14.6885C17.98 14.6785 19.27 14.6785 20.5 14.6785C21.05 14.6785 21.5 14.2285 21.5 13.6785V9.36854C21.5 7.77853 20.74 6.38854 19.57 5.49854ZM11.13 16.9085C11.04 17.2085 10.76 17.4185 10.43 17.4185H6.79C6.74 17.4185 6.7 17.4185 6.66 17.3985C6.3 17.3485 6.04 17.0385 6.04 16.6685C6.04 16.2485 6.37 15.9085 6.79 15.9085H10.43C10.84 15.9085 11.18 16.2485 11.18 16.6685C11.18 16.7485 11.17 16.8385 11.13 16.9085ZM13.91 13.1985C13.82 13.4985 13.54 13.7085 13.21 13.7085H6.79C6.74 13.7085 6.7 13.7085 6.66 13.6885C6.3 13.6385 6.04 13.3285 6.04 12.9585C6.04 12.5385 6.37 12.1985 6.79 12.1985H13.21C13.63 12.1985 13.96 12.5385 13.96 12.9585C13.96 13.0385 13.95 13.1285 13.91 13.1985Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const RequestIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.37 8.88H17.62"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38 8.88L7.13 9.63L9.38 7.38"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.37 15.88H17.62"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38 15.88L7.13 16.63L9.38 14.38"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const RequestBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.19 2.99854H7.81C4.17 2.99854 2 5.16853 2 8.80854V17.1885C2 20.8285 4.17 22.9985 7.81 22.9985H16.19C19.83 22.9985 22 20.8285 22 17.1885V8.80854C22 5.16853 19.83 2.99854 16.19 2.99854ZM9.97 15.8985L7.72 18.1485C7.57 18.2985 7.38 18.3685 7.19 18.3685C7 18.3685 6.8 18.2985 6.66 18.1485L5.91 17.3985C5.61 17.1085 5.61 16.6285 5.91 16.3385C6.2 16.0485 6.67 16.0485 6.97 16.3385L7.19 16.5585L8.91 14.8385C9.2 14.5485 9.67 14.5485 9.97 14.8385C10.26 15.1285 10.26 15.6085 9.97 15.8985ZM9.97 8.89854L7.72 11.1485C7.57 11.2985 7.38 11.3685 7.19 11.3685C7 11.3685 6.8 11.2985 6.66 11.1485L5.91 10.3985C5.61 10.1085 5.61 9.62854 5.91 9.33854C6.2 9.04854 6.67 9.04854 6.97 9.33854L7.19 9.55854L8.91 7.83854C9.2 7.54854 9.67 7.54854 9.97 7.83854C10.26 8.12854 10.26 8.60854 9.97 8.89854ZM17.56 17.6185H12.31C11.9 17.6185 11.56 17.2785 11.56 16.8685C11.56 16.4585 11.9 16.1185 12.31 16.1185H17.56C17.98 16.1185 18.31 16.4585 18.31 16.8685C18.31 17.2785 17.98 17.6185 17.56 17.6185ZM17.56 10.6185H12.31C11.9 10.6185 11.56 10.2785 11.56 9.86854C11.56 9.45854 11.9 9.11854 12.31 9.11854H17.56C17.98 9.11854 18.31 9.45854 18.31 9.86854C18.31 10.2785 17.98 10.6185 17.56 10.6185Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const PaymentIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 10V17C3 18.1046 3.89543 19 5 19H20C21.1046 19 22 18.1046 22 17V10M3 10V7C3 5.89543 3.89543 5 5 5H20C21.1046 5 22 5.89543 22 7V10M3 10H22M5.5 16H8.5M11 16H15"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const PaymentBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 8.54856C22 9.20856 21.46 9.74856 20.8 9.74856H3.2C2.54 9.74856 2 9.20856 2 8.54856V8.53856C2 6.24856 3.85 4.39856 6.14 4.39856H17.85C20.14 4.39856 22 6.25856 22 8.54856Z"
        fill="white"
      />
      <path
        d="M2 12.4485V17.4585C2 19.7485 3.85 21.5985 6.14 21.5985H17.85C20.14 21.5985 22 19.7385 22 17.4485V12.4485C22 11.7885 21.46 11.2485 20.8 11.2485H3.2C2.54 11.2485 2 11.7885 2 12.4485ZM8 18.2485H6C5.59 18.2485 5.25 17.9085 5.25 17.4985C5.25 17.0885 5.59 16.7485 6 16.7485H8C8.41 16.7485 8.75 17.0885 8.75 17.4985C8.75 17.9085 8.41 18.2485 8 18.2485ZM14.5 18.2485H10.5C10.09 18.2485 9.75 17.9085 9.75 17.4985C9.75 17.0885 10.09 16.7485 10.5 16.7485H14.5C14.91 16.7485 15.25 17.0885 15.25 17.4985C15.25 17.9085 14.91 18.2485 14.5 18.2485Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const EarningIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.59 8.39996V13.55C19.59 16.63 17.83 17.95 15.19 17.95H6.39999C5.94999 17.95 5.52 17.91 5.12 17.82C4.87 17.78 4.63 17.71 4.41 17.63C2.91 17.07 2 15.77 2 13.55V8.39996C2 5.31996 3.75999 4 6.39999 4H15.19C17.43 4 19.04 4.95 19.47 7.12C19.54 7.52 19.59 7.92996 19.59 8.39996Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5911 11.4011V16.5511C22.5911 19.6311 20.8311 20.951 18.1911 20.951H9.40109C8.66109 20.951 7.9911 20.8511 7.4111 20.6311C6.2211 20.1911 5.41109 19.2811 5.12109 17.8211C5.52109 17.9111 5.95109 17.951 6.40109 17.951H15.1911C17.8311 17.951 19.5911 16.6311 19.5911 13.5511V8.40106C19.5911 7.93106 19.5511 7.51109 19.4711 7.12109C21.3711 7.52109 22.5911 8.86106 22.5911 11.4011Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7885 13.6199C12.2465 13.6199 13.4285 12.4379 13.4285 10.9799C13.4285 9.52183 12.2465 8.33984 10.7885 8.33984C9.33042 8.33984 8.14844 9.52183 8.14844 10.9799C8.14844 12.4379 9.33042 13.6199 10.7885 13.6199Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.07031 8.78125V13.1813"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5117 8.78125V13.1813"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const EarningBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.17 7.63855C18.74 5.46855 17.13 4.51855 14.89 4.51855H6.10999C3.46999 4.51855 1.70999 5.83855 1.70999 8.91855V14.0686C1.70999 16.2886 2.61999 17.5886 4.11999 18.1486C4.33999 18.2286 4.57999 18.2986 4.82999 18.3386C5.22999 18.4286 5.65999 18.4686 6.10999 18.4686H14.9C17.54 18.4686 19.3 17.1486 19.3 14.0686V8.91855C19.3 8.44855 19.26 8.02855 19.17 7.63855ZM5.52999 12.9986C5.52999 13.4086 5.18999 13.7486 4.77999 13.7486C4.36999 13.7486 4.02999 13.4086 4.02999 12.9986V9.99855C4.02999 9.58855 4.36999 9.24855 4.77999 9.24855C5.18999 9.24855 5.52999 9.58855 5.52999 9.99855V12.9986ZM10.5 14.1386C9.03999 14.1386 7.85999 12.9586 7.85999 11.4986C7.85999 10.0386 9.03999 8.85855 10.5 8.85855C11.96 8.85855 13.14 10.0386 13.14 11.4986C13.14 12.9586 11.96 14.1386 10.5 14.1386ZM16.96 12.9986C16.96 13.4086 16.62 13.7486 16.21 13.7486C15.8 13.7486 15.46 13.4086 15.46 12.9986V9.99855C15.46 9.58855 15.8 9.24855 16.21 9.24855C16.62 9.24855 16.96 9.58855 16.96 9.99855V12.9986Z"
        fill="white"
      />
      <path
        d="M22.3 11.9186V17.0686C22.3 20.1486 20.54 21.4786 17.89 21.4786H9.11001C8.36001 21.4786 7.69001 21.3686 7.11001 21.1486C6.64001 20.9786 6.23001 20.7286 5.90001 20.4086C5.72001 20.2386 5.86001 19.9686 6.11001 19.9686H14.89C18.59 19.9686 20.79 17.7686 20.79 14.0786V8.91857C20.79 8.67857 21.06 8.52857 21.23 8.70857C21.91 9.42857 22.3 10.4786 22.3 11.9186Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};

export const SettingIcon = ({ className }) => {
  return (
    // icon code start

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9.5C13.3809 9.5 14.5 10.6191 14.5 12C14.5 13.3809 13.3809 14.5 12 14.5C10.6191 14.5 9.5 13.3809 9.5 12C9.5 10.6191 10.6191 9.5 12 9.5Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.168 7.25025V7.25025C19.4845 6.05799 17.9712 5.65004 16.7885 6.33852C15.7598 6.93613 14.4741 6.18838 14.4741 4.99218C14.4741 3.61619 13.3659 2.5 11.9998 2.5V2.5C10.6337 2.5 9.52546 3.61619 9.52546 4.99218C9.52546 6.18838 8.23977 6.93613 7.21199 6.33852C6.02829 5.65004 4.51507 6.05799 3.83153 7.25025C3.14896 8.4425 3.55399 9.96665 4.73769 10.6541C5.76546 11.2527 5.76546 12.7473 4.73769 13.3459C3.55399 14.0343 3.14896 15.5585 3.83153 16.7498C4.51507 17.942 6.02829 18.35 7.21101 17.6625H7.21199C8.23977 17.0639 9.52546 17.8116 9.52546 19.0078V19.0078C9.52546 20.3838 10.6337 21.5 11.9998 21.5V21.5C13.3659 21.5 14.4741 20.3838 14.4741 19.0078V19.0078C14.4741 17.8116 15.7598 17.0639 16.7885 17.6625C17.9712 18.35 19.4845 17.942 20.168 16.7498C20.8515 15.5585 20.4455 14.0343 19.2628 13.3459H19.2618C18.2341 12.7473 18.2341 11.2527 19.2628 10.6541C20.4455 9.96665 20.8515 8.4425 20.168 7.25025Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // icon code end
  );
};

export const SettingBoldIcon = () => {
  return (
    // icon code start

    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.1 10.2186C18.29 10.2186 17.55 8.93859 18.45 7.36859C18.97 6.45859 18.66 5.29859 17.75 4.77859L16.02 3.78859C15.23 3.31859 14.21 3.59859 13.74 4.38859L13.63 4.57859C12.73 6.14859 11.25 6.14859 10.34 4.57859L10.23 4.38859C9.78 3.59859 8.76 3.31859 7.97 3.78859L6.24 4.77859C5.33 5.29859 5.02 6.46859 5.54 7.37859C6.45 8.93859 5.71 10.2186 3.9 10.2186C2.86 10.2186 2 11.0686 2 12.1186V13.8786C2 14.9186 2.85 15.7786 3.9 15.7786C5.71 15.7786 6.45 17.0586 5.54 18.6286C5.02 19.5386 5.33 20.6986 6.24 21.2186L7.97 22.2086C8.76 22.6786 9.78 22.3986 10.25 21.6086L10.36 21.4186C11.26 19.8486 12.74 19.8486 13.65 21.4186L13.76 21.6086C14.23 22.3986 15.25 22.6786 16.04 22.2086L17.77 21.2186C18.68 20.6986 18.99 19.5286 18.47 18.6286C17.56 17.0586 18.3 15.7786 20.11 15.7786C21.15 15.7786 22.01 14.9286 22.01 13.8786V12.1186C22 11.0786 21.15 10.2186 20.1 10.2186ZM12 16.2486C10.21 16.2486 8.75 14.7886 8.75 12.9986C8.75 11.2086 10.21 9.74859 12 9.74859C13.79 9.74859 15.25 11.2086 15.25 12.9986C15.25 14.7886 13.79 16.2486 12 16.2486Z"
        fill="white"
      />
    </svg>

    // icon code end
  );
};
